import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
import { Form, Radio, Button } from 'antd';

function ParentsUndertakeForm({
  formData,
  // actions
  nextStep,
  prevStep,
  goToStep,
  result,
  // default
  className,
}) {
  const childClassName = classNames('form-absence', className);

  const [isDisabled, setIsDisabled] = useState(true);

  const [AbsFormUndertake] = Form.useForm();

  useEffect(() => {
    if (formData && formData.hasOwnProperty('parents_undertake')) {
      AbsFormUndertake.setFieldsValue(formData);
      setIsDisabled(false);
    }
  }, [formData]);

  const onFinish = values => {
    result(values);
    nextStep !== undefined && nextStep();
    AbsFormUndertake.resetFields();
  };

  const options = [
    {
      key: 'with-parent',
      value: 'with-parent',
      label: (
        <>
          <span className="label__description">
            accompagner leur enfant sur tout le trajet
          </span>
        </>
      ),
    },
    {
      key: 'alone',
      value: 'alone',
      label: (
        <>
          <span className="label__description">
            autoriser leur enfant à se déplacer tout seul
          </span>
        </>
      ),
    },
  ];

  return (
    <div className={childClassName}>
      <Form
        form={AbsFormUndertake}
        className="form-absence__form"
        name="form_absence_undertake"
        initialValues=""
        onFinish={onFinish}
        onValuesChange={() => setIsDisabled(false)}
      >
        <Form.Item name="parents_undertake">
          <Radio.Group
            className="radio-group radio-group--big"
            options={options}
            optionType="Radio"
          />
        </Form.Item>

        <div className="absence-actions-wrapper">
          <Button
            className="btn-previous"
            onClick={() => goToStep(!formData?.media ? 4 : 5)}
          >
            Précédent
          </Button>
          <Button
            className="next-btn"
            form="form_absence_undertake"
            htmlType="submit"
            disabled={isDisabled}
          >
            Suivant
          </Button>
        </div>
      </Form>
    </div>
  );
}

ParentsUndertakeForm.defaultProps = {};
ParentsUndertakeForm.propTypes = {
  result: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
  goToStep: PropTypes.func.isRequired,
};

export default memo(ParentsUndertakeForm);
